import { DiamondWhite } from "@/assets/icons";
import { Button, Card, Skeleton, Tooltip } from "antd";

import cx from "classnames";
import { upperCase } from "lodash";
import {
  IMyGoalsMilestoneQuestion,
  IStateQuickQuestion,
} from "../mygoals.type";
import { useLocale } from "@/localization";
import QuestionInputs from "./question-inputs";
import { useEffect, useState } from "react";
import { useGetDepartments } from "@/hooks/useGoals";
import { useListExpertise } from "@/hooks/useTags";
import Image from "next/image";
import questionMarkIcon from "@/assets/question-mark-icon.png";
import { useAnalytics } from "@/hooks/useAnalytics";

export default function MyGoalsQuestionMilestone({
  focusedSkill,
  isPremium,
  fromOtherUser,
  dataQuickQuestion,
  isFetchingQuickQuestion,
  isLoadingQuestion,
  isLoadingSubmitQuestion,
  refetchQuickQuestion,
  onSubmit,
  holdMax,
  holdMaxSet,
  isDashboard,
  hideQuickQuestion,
  quickQuestionClassName
}: IMyGoalsMilestoneQuestion) {
  const {
    locale: {
      page_goals: { quick_questions_section },
    },
  } = useLocale();

  // fetch query
  const { data: dataDepartments } = useGetDepartments();
  const { data: dataExpertises } = useListExpertise();

  const [stateQuickQuestion, stateQuickQuestionSet] =
    useState<IStateQuickQuestion>({
      text: "",
      strings_array_input: "",
      strings_array: [],
      userDepartmentId: "",
      expertises: "",
      date: null,
      number: 0,
    });

  useEffect(() => {
    if (isFetchingQuickQuestion || isLoadingQuestion) {
      stateQuickQuestionSet({
        text: "",
        strings_array_input: "",
        strings_array: [],
        userDepartmentId: "",
        expertises: "",
        date: null,
        number: 0,
      });
    }
  }, [isFetchingQuickQuestion, isLoadingQuestion]);
  // console.log(dataQuickQuestion);

  const { track } = useAnalytics();
  return (
    <>
      {/* {fromOtherUser && isPremium && (
        <Card
          title={
            <h3 className="font-bold text-lg text-white ">
              Focused Milestone Category
            </h3>
          }
        >
          {focusedSkill ? (
            <>
              <h3
                className={cx(
                  "text-lg mb-4 font-bold",
                  {
                    "text-red-500": upperCase(focusedSkill?.color) === "RED",
                  },
                  {
                    "text-green-500":
                      upperCase(focusedSkill?.color) === "GREEN",
                  },
                  {
                    "text-blue-500": upperCase(focusedSkill?.color) === "BLUE",
                  },
                  {
                    "text-yellow": upperCase(focusedSkill?.color) === "YELLOW",
                  },
                )}
              >
                {focusedSkill?.skillTrackName}
              </h3>
              <div
                className={cx(
                  `flex flex-col gap-5 p-4 border-l-4 max-w-sm border-t border-b border-r border-r-black border-t-black border-b-black`,
                  {
                    "border-red-500": upperCase(focusedSkill?.color) === "RED",
                  },
                  {
                    "border-green-500":
                      upperCase(focusedSkill?.color) === "GREEN",
                  },
                  {
                    "border-blue-500":
                      upperCase(focusedSkill?.color) === "BLUE",
                  },
                  {
                    "border-yellow":
                      upperCase(focusedSkill?.color) === "YELLOW",
                  },
                )}
              >
                <div className="flex flex-col justify-between gap-2">
                  <div className={`flex gap-3 flex-col`}>
                    <p className="text-sm font-bold">{focusedSkill?.name}</p>
                    <p className="text-xs">{focusedSkill?.description}</p>
                  </div>
                  <div>
                    <DiamondWhite />
                  </div>
                </div>
              </div>

              {focusedSkill?.isCompletedFocusedSkill && (
                <div className="mt-4">
                  <p>The milestone has been completed</p>
                </div>
              )}
            </>
          ) : (
            <p>There's no focused milestone currently</p>
          )}
        </Card>
      )} */}

      {!hideQuickQuestion
        ? !fromOtherUser && (
            <Card
              className={quickQuestionClassName}
              title={
                <div className="flex w-full items-center justify-between">
                  <h3 className="flex items-center gap-x-2">
                    {quick_questions_section.title}
                    <Tooltip
                      overlayInnerStyle={{
                        backgroundColor: "#1a1a1a !important",
                      }}
                      overlayStyle={{ opacity: 1 }}
                      overlayClassName="text-white rouned-sm"
                      title="Your answers help to tailor recommendations and to complete your profile with ease. Skip questions that don’t fit."
                      placement="bottom"
                    >
                      <Image
                        alt="question-mark-icon"
                        src={questionMarkIcon}
                        className="block w-[12px] h-[12px]"
                      />
                      <style jsx>{`
                        .ant-tooltip-inner {
                          background-color: #1a1a1a !important;
                          color: white;
                        }
                      `}</style>
                    </Tooltip>
                  </h3>
                  {dataQuickQuestion?.label ===
                  "You've answered all of the quick questions!" ? (
                    ""
                  ) : (
                    <Button
                      loading={isFetchingQuickQuestion}
                      type="text"
                      onClick={() => {
                        dataQuickQuestion?.category === "sensitive"
                          ? onSubmit(true, "skippedSensitiveQuestion")
                          : dataQuickQuestion?.field ===
                              "sensitiveQuestionConsent"
                            ? onSubmit(false)
                            : refetchQuickQuestion();
                            track("Skip quick question widget dashboard", "Click", `${dataQuickQuestion?.label || "Unknown Question"} - ${dataQuickQuestion?.field || "Unknown Field"}`);
                      }}
                    >
                      Skip Question
                    </Button>
                  )}
                </div>
              }
            >
              {/* {dataQuickQuestion?.category === "sensitive" && (
            <div className="bg-neutral-600 flex items-center gap-2 py-3 px-3 mb-4">
              <ExclamationCircleFilled className="text-amber-500" />
              Please answer this question to continue
            </div>
          )} */}
              {isLoadingQuestion ||
              isLoadingSubmitQuestion ||
              isFetchingQuickQuestion ? (
                <div className="flex flex-col gap-2">
                  {new Array(3).fill(undefined).map((_, i) => (
                    <Skeleton.Input
                      active
                      key={`Skeleton-${i}`}
                      size="small"
                      block
                    />
                  ))}
                </div>
              ) : (
                <div
                  className={`flex flex-col gap-7 lg:overflow-y-auto h-full ${isDashboard ? "lg:h-60" : "lg:h-72"}`}
                >
                  {dataQuickQuestion?.labelIsHTML ||
                  (dataQuickQuestion.label &&
                    dataQuickQuestion?.label?.startsWith("<p>")) ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dataQuickQuestion.label.replace(
                          /href='www\./g,
                          "href='https://www.",
                        ),
                      }}
                    ></div>
                  ) : (
                    <p>{dataQuickQuestion.label}</p>
                  )}
                  <QuestionInputs
                    isLoadingSubmitQuestion={isLoadingQuestion}
                    type={dataQuickQuestion?.type}
                    stateQuickQuestion={stateQuickQuestion}
                    stateQuickQuestionSet={stateQuickQuestionSet}
                    parent={dataQuickQuestion?.parent}
                    onSubmit={(val:any, parent:any) => {
                      onSubmit(val, parent);
                      track("Submit quick question widget dashboard", "Click", dataQuickQuestion?.label || "Unknown Question");
                    }}
                    holdMax={holdMax}
                    holdMaxSet={holdMaxSet}
                    max={dataQuickQuestion?.max}
                    dataDepartments={dataDepartments}
                    dataExpertises={dataExpertises as any[]}
                    options={dataQuickQuestion?.options}
                    label={dataQuickQuestion?.label}
                  />
                </div>
              )}
            </Card>
          )
        : null}
    </>
  );
}
